import createReducer from 'common/reducerBase';
import CameraRecord from '../data/CameraRecord';
import { types as ats } from '../actions';

export default {
  camera: createReducer(CameraRecord(), {
    [ats.SET_USER_ALLOWED_CAMERA]: (state) =>
      state.merge({
        cameraLoading: false,
        cameraAllowed: true,
        cameraNotFound: false,
      }),

    [ats.SET_CAMERA_LOADING]: (state, { payload }) =>
      state.merge({
        cameraLoading: payload.loading,
        cameraNotFound: false,
        cameraAllowed: false,
      }),

    [ats.SET_CAMERA_NOT_FOUND]: (state, { payload }) =>
      state.merge({
        cameraLoading: false,
        cameraNotFound: payload.status,
        cameraAllowed: false,
      }),
  }),
};
